export default __webpack_public_path__ + "63b0773d8e93c0f0415a6f9942783e5c.svg";